import { createContext } from 'react';

export const GuidanceTipsContext = createContext();
